export const TOGGLE_ASIA_POPUP = 'TOGGLE_ASIA_POPUP';
export const OPEN_ASIA_POPUP = 'OPEN_ASIA_POPUP';
export const SET_DESTINATION_URL = 'SET_DESTINATION_URL';

export const toggleAsiaPopup = () => async (dispatch) => {
  dispatch({
    type: TOGGLE_ASIA_POPUP,
  });
};

export const openAsiaPopup = () => async (dispatch) => {
  dispatch({
    type: OPEN_ASIA_POPUP,
  });
};

export const setDestinationUrl = (url) => async (dispatch) => {
  if (url) {
    dispatch({
      type: SET_DESTINATION_URL,
      payload: url,
    });
  }
};
